import { Form } from '@/components';
import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledLabel = styled.span`
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${pickThemeColor('GREY')};
  text-align: left;
`;

export const StyledWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  width: 100%;
`;

export const StyledForm = styled(Form)`
  .ant-form-item {
    margin: 0;
  }

  &&& .ant-form-item-label > label {
    ${pickThemeFontStyles('14', '20', 'NORMAL')};
    color: ${pickThemeColor('GREY')};
  }
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;
  width: 100%;
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 0.25rem;
  margin-top: 0.5rem;
`;

export const StyledText = styled.div`
  ${pickThemeFontStyles('16', '26', 'NORMAL')};
  word-break: break-all;
`;
